import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'onboarding';

export default {
  async setupOrganization(body) {
    const url = mountUrl(`/${BASE_PATH}/organization`);
    return api.post(url, body);
  },
  async setupUsers(body) {
    const url = mountUrl(`/${BASE_PATH}/users`);
    return api.post(url, body);
  },
  async setupDomain(body) {
    const url = mountUrl(`/${BASE_PATH}/domain`);
    return api.post(url, body);
  },
  async setupDomainV2(body) {
    const url = mountUrl(`/${BASE_PATH}/domain/v2`);
    return api.post(url, body);
  },
  async validateDomain(body) {
    const url = mountUrl(`/web/organization_parameter/domain-url/exists`);
    return api.post(url, body);
  },
  async setupWebsite(body) {
    const url = mountUrl(`/${BASE_PATH}/website`);
    return api.post(url, body);
  },
  checkDomain(domain) {
    const url = mountUrl(`/${BASE_PATH}/domain/${domain}`);
    return api.get(url);
  },
  uploadImage(websiteId, body, type) {
    const url = mountUrl(`/${BASE_PATH}/${websiteId}/${type}`);
    return api.post(url, body);
  },
  updateUser(userId, body) {
    const url = mountUrl(`/${BASE_PATH}/users/${userId}`);
    return api.put(url, body);
  }
};
